import { render, staticRenderFns } from "./header.vue?vue&type=template&id=04147138&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=04147138&prod&lang=less&scoped=true"
import style1 from "./header.vue?vue&type=style&index=1&id=04147138&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04147138",
  null
  
)

export default component.exports